/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';


export const getFiles = (feature: BaseFeature): string[] => {
    return [
        'ssd1306.py',
    ];
};

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks = [];

    const NAME = feature.getSettingValue('NAME');
    const I2C = feature.getSettingValue('I2C');
    const LCD_SCREEN_WIDGET_COLUMNS = feature.getSettingValue('LCD_SCREEN_WIDGET_COLUMNS');
    const LCD_SCREEN_WIDGET_ROWS = feature.getSettingValue('LCD_SCREEN_WIDGET_ROWS');
    const SDA = feature.getSettingValue('SDA');
    const SCL = feature.getSettingValue('SCL');
    // const GND = this.getSettingValue('GND');
    // const VCC = this.getSettingValue('VCC');
    const SCREENS = feature.getSettingValue('SCREENS');


    const boardType = PlatformUtils.getPlaformWokwiId(feature.project.device.id);

    const SDAPIN = Peripherals.getPin(SDA, feature.project.device.id)?.peripherals
        .filter(p => p.peripheralType === 'gpio')[0]?.peripheralPort;

    const SCLPIN = Peripherals.getPin(SCL, feature.project.device.id)?.peripherals
        .filter(p => p.peripheralType === 'gpio')[0]?.peripheralPort;

    blocks.push({
        location: 'IMPORTS',
        blockType: BlockType.CODE,
        id: 'import_ssd1306',
        template: 'import ssd1306',
    });

    const i2cID = '1';

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `${NAME} = ssd1306.SSD1306_I2C(${LCD_SCREEN_WIDGET_COLUMNS}, ${LCD_SCREEN_WIDGET_ROWS}, machine.I2C(${i2cID}, scl=machine.Pin(${SCLPIN}), sda=machine.Pin(${SDAPIN})))`,
    });

    blocks.push({
        location: 'WOKWI_PARTS',
        blockType: BlockType.CODE,
        template: `
{
    "type": "board-ssd1306",
    "id": "${NAME}",
    "top": 0,
    "left": -100,
    "attrs": {  }
},`,
    });

    blocks.push({
        location: 'WOKWI_CONNECTIONS',
        blockType: BlockType.CODE,
        template: `
            ["${NAME}:SDA", "${boardType}:GP${SDAPIN}", "green", ["v0"]],
            ["${NAME}:SCL", "${boardType}:GP${SCLPIN}", "blue", ["v0"]],
            `,
    });

    const widgetsArrayName = `${NAME}_widgets`;

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `${widgetsArrayName} = []`,
    });

    for (let j = 0; j < SCREENS.length; j++) {
        const screen = SCREENS[j];
        const WIDGETS = screen.getSettingValue('WIDGETS');

        for (let i = 0; i < WIDGETS.length; i++) {
            const widget = WIDGETS[i].getWidgetObject();
            if (widget.type === 'lcd_text_widget') {
                blocks.push({
                    location: 'display_init_widgets',
                    blockType: BlockType.CODE,
                    template: `
${widgetsArrayName}.append(DisplayWidget(
    type='text',
    x=${widget.x},
    y=${widget.y},
    width=${widget.w},
    height=${widget.h},
    screen=${j},
    text='${widget.text}',
))`,
                });
            } else if (widget.type === 'lcd_image_widget') {
                const IMG_FILE = widget.img ? widget.img.split('\n')[0] : '';
                blocks.push({
                    location: 'display_init_widgets',
                    blockType: BlockType.CODE,
                    template: `
${widgetsArrayName}.append(DisplayWidget(
    type='image',
    x=${widget.x},
    y=${widget.y},
    width=${widget.w},
    height=${widget.h},
    screen=${j},
    text='${IMG_FILE}',
))`,
                });
            }
        }
    }

    blocks.push({
        location: 'VS_MICROPYTHON_UPLOADS',
        blockType: BlockType.CODE,
        template: `
"+",
"cp",
"ssd1306.py",
":ssd1306.py",
            `,
    });

    blocks.push({
        location: 'display_display_widgets',
        blockType: BlockType.CODE,
        template: `
${NAME}.fill(0)
for widget in ${widgetsArrayName}:
    if widget.type == 'text':
        ${NAME}.text(widget.text, widget.x, widget.y)
        pass
    elif widget.type == 'image':

        pass
${NAME}.show()`,
    });

    return blocks;
};
